import $ from 'jquery';
import Component from './index';
import Pjax from './pjax';
import Filters from './filters';

class Filterable extends Component {
    mount() {
        // Create filters.
        this.filtersSelector = '.js-filters';
        this.$filters = $(this.filtersSelector);
        this.filters = new Filters(this.filtersSelector);

        // Create filter list pjax loader.
        this.listSelector = '.js-list-container';
        this.$list = $(this.listSelector);
        this.pjax = new Pjax(this.listSelector);

        this.$loader = $('.js-list-loader');

        this.addEventListeners();

        // If this is the people page, set default filters so that "Leadership" loads instead of "All"
        if ($('.people').length > 0) {
            this.setDefaultFilters();
        }
    }

    addEventListeners() {
        // Dynamically update filter list when filter link is changed.
        this.filters.on('change', (_, url) => {
            this.pjax.loadUrl(url);
        });
        this.pjax.on('loading', this.onPjaxLoading.bind(this));
        this.pjax.on('loaded', this.onPjaxLoaded.bind(this));
    }

    setDefaultFilters() {
        this.$selectedFilter = $('.js-dropdown-list .selected');
        const defaultURL = this.$selectedFilter.attr('href');
        this.pjax.loadUrl(defaultURL);
    }

    onPjaxLoading() {
        this.showLoader();

        if ('matchMedia' in window) {
            this.mqMd = matchMedia('(max-width: 768px)');
        }

        if (this.mqMd.matches) {
            $('html, body').animate(
                {
                    scrollTop: $(this.filtersSelector).offset().top,
                },
                400
            );
        }
    }

    onPjaxLoaded(e, $doc) {
        // Hide loading indicator.
        this.hideLoader();

        // Prepare filters to be replaced.
        this.filters.unmount();

        // Update filters with new content.
        this.$filters.html($doc.find(this.filtersSelector).html());

        // Re-mount filters with new content.
        this.filters.mount();
    }

    showLoader() {
        this.$list.hide();
        this.$loader.show();
    }

    hideLoader() {
        this.$list.show();
        this.$loader.hide();
    }

    static init() {
        const $el = $('.filterable');
        if ($el.length > 0) {
            new Filterable($el);
        }
    }
}

export default Filterable;
